<div class="tool-buttons" [ngClass]="{'second-line': splitIdx === 1}">
	<div class="left-tool">
		<mat-icon class="tool-button" *ngIf="showJointChangeLeft" svgIcon="{{splitIdx===0 ? 'icon-chevron-right' : 'icon-chevron-left'}}" title="Synchronous shift" (click)="clickJointChange('left')"></mat-icon>
	</div>
	<div class="right-tool">
		<mat-icon class="tool-button" *ngIf="showJointChangeRight" svgIcon="{{splitIdx===0 ? 'icon-chevron-right' : 'icon-chevron-left'}}" title="Synchronous shift" (click)="clickJointChange('right')"></mat-icon>
	</div>
</div>
<div class="centerline-wrap">
	<div class="centerline-side">
		<input name="fromAddrLeft" [(ngModel)]="rec[fromLeftColName]" (ngModelChange)="onEdit()">
		<input name="toAddrLeft" [(ngModel)]="rec[toLeftColName]" (ngModelChange)="onEdit()">
	</div>
	<div class="road-draw">
		<div class="road-draw-inner">
			<div class="arrow-wrap">
				<div class="arrow-line"></div>
				<div class="arrow-point"></div>
			</div>
		</div>
	</div>
	<div class="centerline-side">
		<input name="fromAddrRight" [(ngModel)]="rec[fromRightColName]" (ngModelChange)="onEdit()">
		<input name="toAddrRight" [(ngModel)]="rec[toRightColName]" (ngModelChange)="onEdit()">
	</div>
</div>
